// extracted by mini-css-extract-plugin
export default {"wrapper":"ReferralBanner_wrapper__196J7","textWrapper":"ReferralBanner_textWrapper__4PdiV","cta":"ReferralBanner_cta__6cdOo"};